import { useQuery } from '@tanstack/react-query';
import { dealEventLogControllerGetUnreadOptions } from '@dealstack/shared/lib/backendClient/@tanstack/react-query.gen';

const UNREAD_STALE_TIME_MS = 60_000;

export const dealEventLogRequestOptions = (dealId: string) => ({
	headers: { 'deal-id': dealId },
});

export const useDealEventLogUnread = (dealId: string, enabled: boolean) =>
	useQuery({
		...dealEventLogControllerGetUnreadOptions(dealEventLogRequestOptions(dealId)),
		enabled: enabled && !!dealId,
		staleTime: UNREAD_STALE_TIME_MS,
	});
